import { render, staticRenderFns } from "./FooterTablet.vue?vue&type=template&id=9ecae7e8&scoped=true"
import script from "./FooterTablet.vue?vue&type=script&lang=js"
export * from "./FooterTablet.vue?vue&type=script&lang=js"
import style0 from "./FooterTablet.vue?vue&type=style&index=0&id=9ecae7e8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9ecae7e8",
  null
  
)

export default component.exports